/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-edit': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12.019 6.679L9.324 3.984l1.948-1.95 2.694 2.695-1.947 1.95zm3.385-3.341l-.001-.001L12.665.599c-.741-.74-2.014-.774-2.716-.07L.953 9.527a1.973 1.973 0 00-.57 1.214l-.38 4.17a1.002 1.002 0 001.088 1.086l4.17-.38a1.974 1.974 0 001.214-.567l8.997-8.997c.728-.73.697-1.948-.068-2.714z" _fill="#566473"/>'
  }
})
